import { render } from "./SelectDomainDialog.vue?vue&type=template&id=cc0ac3a4"
import script from "./SelectDomainDialog.vue?vue&type=script&lang=js"
export * from "./SelectDomainDialog.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__